module.exports = __webpack_public_path__ + "img/MW.dc908025.png";